"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.patientsReports = exports.getDispenseData = exports.getDistributorOrdering = exports.getDistributors = exports.getClaimPDFs = exports.listcyclecount = exports.inventoryCountReport = exports.insurancePaymentReport = exports.userAuditTrail = exports.generatePdfZips = exports.loadPdfZips = exports.loadRequiredAssets = exports.certificationsReport = exports.transactionCounts = exports.accountsReceivableAging = exports.networkContacts = exports.negativeBalances = exports.reversalsReport = exports.reportsB2 = exports.claimErrorReport = exports.erxReport = exports.readMailMessage = exports.patientPaymentReport = exports.productAuditReport = exports.mailReport = exports.erxReportTemp = exports.salesUsage = exports.orderingAnalytics = exports.clinicReimbursement = exports.claimAnalytics = void 0;
const endpoint_1 = require("api/endpoint");
const permissions_1 = require("shared/permissions");
exports.claimAnalytics = endpoint_1.createEndpoint()({
    method: "post",
    path: "reports/claim-analytics",
    permissions: permissions_1.PERMISSIONS.DISPENSIFY_CLAIM_ANALYTICS
});
exports.clinicReimbursement = endpoint_1.createEndpoint()({
    method: "post",
    path: "reports/clinic-reimbursement",
    permissions: permissions_1.PERMISSIONS.DISPENSIFY_CLAIM_ANALYTICS
});
exports.orderingAnalytics = endpoint_1.createEndpoint()({
    method: "post",
    path: "reports/order-analytics",
    permissions: permissions_1.PERMISSIONS.DISPENSIFY_CLAIM_ANALYTICS
});
exports.salesUsage = endpoint_1.createEndpoint()({
    method: "post",
    path: "reports/sales-usage-summary",
    permissions: permissions_1.PERMISSIONS.DISPENSIFY_CLAIM_ANALYTICS
});
/** REMOVE AFTER LIVE UPDATE */
exports.erxReportTemp = endpoint_1.createEndpoint()({
    method: "post",
    path: "reports/erx-report-temp",
    permissions: permissions_1.PERMISSIONS.DISPENSIFY_CLAIM_ANALYTICS
});
exports.mailReport = endpoint_1.createEndpoint()({
    method: "post",
    path: "reports/mail-report",
    permissions: permissions_1.PERMISSIONS.DISPENSIFY_CLAIM_ANALYTICS
});
exports.productAuditReport = endpoint_1.createEndpoint()({
    method: "post",
    path: "reports/product-audit-report",
    permissions: permissions_1.PERMISSIONS.DISPENSIFY_CLAIM_ANALYTICS
});
// D-002.911
exports.patientPaymentReport = endpoint_1.createEndpoint()({
    method: "post",
    path: "reports/patient-payment-report",
    permissions: permissions_1.PERMISSIONS.DISPENSIFY_CLAIM_ANALYTICS
});
exports.readMailMessage = endpoint_1.createEndpoint()({
    method: "post",
    path: "reports/mail-report-message",
    permissions: permissions_1.PERMISSIONS.DISPENSIFY_CLAIM_ANALYTICS,
});
exports.erxReport = endpoint_1.createEndpoint()({
    method: "post",
    path: "reports/erx-report",
    permissions: permissions_1.PERMISSIONS.DISPENSIFY_CLAIM_ANALYTICS
});
//E-064.51
exports.claimErrorReport = endpoint_1.createEndpoint()({
    method: "post",
    path: "reports/claim-error-report",
    permissions: permissions_1.PERMISSIONS.DISPENSIFY_CLAIM_ANALYTICS
});
exports.reportsB2 = endpoint_1.createEndpoint()({
    method: "post",
    path: "reports/reversals-report-b2",
    permissions: permissions_1.PERMISSIONS.DISPENSIFY_CLAIM_ANALYTICS
});
exports.reversalsReport = endpoint_1.createEndpoint()({
    method: "post",
    path: "reports/reversals-report",
    permissions: permissions_1.PERMISSIONS.DISPENSIFY_CLAIM_ANALYTICS
});
exports.negativeBalances = endpoint_1.createEndpoint()({
    method: "post",
    path: "reports/negative-balances",
    permissions: permissions_1.PERMISSIONS.DISPENSIFY_CLAIM_ANALYTICS
});
exports.networkContacts = endpoint_1.createEndpoint()({
    method: "get",
    path: "reports/network-contacts",
    permissions: permissions_1.PERMISSIONS.DISPENSIFY_CLAIM_ANALYTICS
});
exports.accountsReceivableAging = endpoint_1.createEndpoint()({
    method: "post",
    path: "reports/ar-aging-report",
    permissions: permissions_1.PERMISSIONS.DISPENSIFY_CLAIM_ANALYTICS
});
exports.transactionCounts = endpoint_1.createEndpoint()({
    method: "post",
    path: "reports/transaction-counts",
    permissions: permissions_1.PERMISSIONS.DISPENSIFY_CLAIM_ANALYTICS
});
exports.certificationsReport = endpoint_1.createEndpoint()({
    method: "post",
    path: "reports/certifications-report",
    permissions: permissions_1.PERMISSIONS.DISPENSIFY_CLAIM_ANALYTICS
});
exports.loadRequiredAssets = endpoint_1.createEndpoint()({
    method: "get",
    path: "reports/load-required-assets",
    permissions: permissions_1.PERMISSIONS.DISPENSIFY_CLAIM_ANALYTICS
});
exports.loadPdfZips = endpoint_1.createEndpoint()({
    method: "get",
    path: "reports/load-pdf-zips",
    permissions: permissions_1.PERMISSIONS.DISPENSIFY_CLAIM_ANALYTICS
});
exports.generatePdfZips = endpoint_1.createEndpoint()({
    method: "post",
    path: "reports/generate-pdf-zips",
    permissions: permissions_1.PERMISSIONS.DISPENSIFY_CLAIM_ANALYTICS
});
exports.userAuditTrail = endpoint_1.createEndpoint()({
    method: "post",
    path: "reports/audit-trail",
    permissions: permissions_1.PERMISSIONS.DISPENSIFY_CLAIM_ANALYTICS
});
exports.insurancePaymentReport = endpoint_1.createEndpoint()({
    method: "post",
    path: "reports/insurance-payment-report",
    permissions: permissions_1.PERMISSIONS.DISPENSIFY_CLAIM_ANALYTICS
});
exports.inventoryCountReport = endpoint_1.createEndpoint()({
    method: "post",
    path: "reports/inventory-count-report",
    permissions: permissions_1.PERMISSIONS.DISPENSIFY_CLAIM_ANALYTICS
});
exports.listcyclecount = endpoint_1.createEndpoint()({
    method: "post",
    path: "reports/cycle-count-report",
    permissions: permissions_1.PERMISSIONS.DISPENSIFY_CLAIM_ANALYTICS
});
exports.getClaimPDFs = endpoint_1.createEndpoint()({
    method: "post",
    path: "reports/get-claims-pdfs",
    permissions: permissions_1.PERMISSIONS.DISPENSIFY_CLAIM_ANALYTICS
});
exports.getDistributors = endpoint_1.createEndpoint()({
    method: "get",
    path: "reports/get-distributors",
    permissions: permissions_1.PERMISSIONS.DISPENSIFY_CLAIM_ANALYTICS
});
exports.getDistributorOrdering = endpoint_1.createEndpoint()({
    method: "post",
    path: "reports/distributor-ordering",
    permissions: permissions_1.PERMISSIONS.DISPENSIFY_CLAIM_ANALYTICS
});
exports.getDispenseData = endpoint_1.createEndpoint()({
    method: "post",
    path: "reports/dispense-report",
    permissions: permissions_1.PERMISSIONS.DISPENSIFY_CLAIM_ANALYTICS
});
//E-037.2
exports.patientsReports = endpoint_1.createEndpoint()({
    method: "post",
    path: "reports/patient-reports",
    permissions: permissions_1.PERMISSIONS.DISPENSIFY_PATIENT_READ
});



//////////////////
// WEBPACK FOOTER
// ./src/api/reporting/reporting-client.ts
// module id = 998
// module chunks = 0 1 2